// ============================================================================
// ADIS 95 - Testimonial Data
// Extracted from SiteOne Crawler offline export of adis95.fr
// ============================================================================

export interface Testimonial {
  slug: string
  title: string
  quote: string
  date: string
  imageUrl: string
  author: string
  source: string
  sourceUrl: string
  rating: number
}

export const testimonials: Testimonial[] = [
  {
    slug: "allez-chez-adis-95",
    title: "Allez chez ADIS 95",
    quote:
      "Tres bon conseil, vendeurs competents, gros choix de fraise en CMT, il peuvent vendre du Tormek, pour ceux que cela interesse, meme du Bessay. Et en plus, ils savent affuter!",
    date: "2020-02-26",
    imageUrl: "/images/remote/avatar-petitscopeauxdebois.jpg",
    author: "PetitsCopeauxdebois",
    source: "L'Air du Bois",
    sourceUrl: "https://www.lairdubois.fr/fournisseurs/209-asm-adis-95.html",
    rating: 5,
  },
  {
    slug: "super-pro",
    title: "Super pro",
    quote:
      "Un enorme choix de fraises, lames, materiel... et un service au top (vendeurs sympa, de bon conseil). Je fais affuter toutes les lames chez eux et n'ai jamais ete decu du resultat.",
    date: "2020-02-26",
    imageUrl: "/images/remote/avatar-florentcpt.jpg",
    author: "florentcpt",
    source: "L'Air du Bois",
    sourceUrl: "https://www.lairdubois.fr/fournisseurs/209-asm-adis-95.html",
    rating: 5,
  },
  {
    slug: "premier-contact",
    title: "Premier contact tres agreable",
    quote:
      "Premier contact par telephone tres agreable avec le commercial. Il a pu me communiquer des fourchettes de prix pour l'affutage de mes outils a main en tant que particulier.",
    date: "2023-04-10",
    imageUrl: "/images/remote/avatar-gabylebucheron.png",
    author: "GabyLeBucheron",
    source: "L'Air du Bois",
    sourceUrl: "https://www.lairdubois.fr/fournisseurs/209-asm-adis-95.html",
    rating: 5,
  },
  // --- Google Reviews (4+ stars) ---
  {
    slug: "toujours-un-plaisir",
    title: "Toujours un plaisir",
    quote:
      "Toujours un plaisir d'aller chez ce fournisseur de Festool avec un personnel très compétent, souriant et très patient.",
    date: "2021-07-01",
    imageUrl: "",
    author: "Client Google",
    source: "Google",
    sourceUrl: "https://www.google.com/maps/place/ADIS+95",
    rating: 5,
  },
  {
    slug: "accueil-chaleureux",
    title: "Accueil chaleureux et souriant",
    quote:
      "Accueil chaleureux et souriant.",
    date: "2025-01-15",
    imageUrl: "",
    author: "Client Google",
    source: "Google",
    sourceUrl: "https://www.google.com/maps/place/ADIS+95",
    rating: 4,
  },
  {
    slug: "des-pros-de-proximite",
    title: "Des pros de proximité",
    quote:
      "Des pros de proximité, tout ce qu'on aime dans ce domaine. Merci Adis !",
    date: "2020-06-15",
    imageUrl: "",
    author: "Client Google",
    source: "Google",
    sourceUrl: "https://www.google.com/maps/place/ADIS+95",
    rating: 5,
  },
  {
    slug: "equipe-accueillante",
    title: "Équipe accueillante",
    quote:
      "Équipe accueillante, de bon conseil...",
    date: "2021-07-15",
    imageUrl: "",
    author: "Client Google",
    source: "Google",
    sourceUrl: "https://www.google.com/maps/place/ADIS+95",
    rating: 5,
  },
  {
    slug: "personnel-agreable",
    title: "Personnel agréable et compétent",
    quote:
      "Personnel agréable et compétent.",
    date: "2021-10-15",
    imageUrl: "",
    author: "Client Google",
    source: "Google",
    sourceUrl: "https://www.google.com/maps/place/ADIS+95",
    rating: 5,
  },
  {
    slug: "affuteur-professionnel",
    title: "Affûteur professionnel",
    quote:
      "Affûteur professionnel.",
    date: "2021-09-15",
    imageUrl: "",
    author: "Client Google",
    source: "Google",
    sourceUrl: "https://www.google.com/maps/place/ADIS+95",
    rating: 4,
  },
]

// Helper: get testimonial by slug
export function getTestimonialBySlug(
  slug: string
): Testimonial | undefined {
  return testimonials.find((t) => t.slug === slug)
}
